import React, {Fragment} from 'react';
import {Card, Flex, NoWrap, Display} from 'components';
import {useSelectorInBackground, moment, pluralize, useNamedSelector} from 'helpers';
import {reject, sum} from 'helpers';

export function Footer({ id, detailed }) {
  const goal = useNamedSelector('goals.details', { id });
  return Boolean(goal.milestones.length || goal.allActivities.length || goal.target_date) && (
    <Content goal={goal} detailed={detailed} />
  );
}

function Content({ goal, detailed }) {
  const [ ref, { milestones, activities } = placeholder, processing ] = useSelectorInBackground('goals.stats', goal.goal);
  const progress = reject([
    milestones.completed/milestones.total,
    activities.completed/activities.total,
  ], isNaN);
  const weight = 1 / progress.length;
  return (
    <Display what={detailed && Card.Footer} className="borderless">
      <Card.Progress now={sum(progress.map(value => value*weight))}>
        <Flex ref={ref}>
          { processing &&
            <span className="secondary">computing..</span>
          }
          { Boolean(milestones.total) &&
            <NoWrap><b>{milestones.completed}/{milestones.total}</b> { pluralize('milestone', milestones.total) }</NoWrap>
          }
          { Boolean(activities.total) &&
            <NoWrap><b>{activities.completed}/{activities.total}</b> { pluralize('activity', activities.total) }</NoWrap>
          }
          { goal.target_date &&
            <Card.Highlight className="pull-right">
              { moment.unix(goal.target_date).format() }
            </Card.Highlight>
          }
        </Flex>
      </Card.Progress>
    </Display>
  );
}

const placeholder = {
  activities: { total: 0, completed: 0 },
  milestones: { total: 0, completed: 0 },
}
